<div
  [class]="currentTheme"
  [class.transparent]="isTransparent"
  [class.large]="currentSize === 'large'"
  [class.small]="currentSize === 'small' && !currentIcon"
  [class.small-with-icon]="currentSize === 'small' && currentIcon"
  [class.square]="currentShape === 'square'"
  [class.revert]="isReverted"
>
  @if (currentIcon && currentIcon !== 'bullet') {
  <mat-icon [svgIcon]="currentIcon"></mat-icon>
  }
  <!-- a cut label ends with an ellipsis and shows in full in a tooltip -->
  <p
    [class.bullet]="currentIcon === 'bullet'"
    wmFrontTooltip="data"
    position="top"
    [offset]="-15"
    [onlyOnOverflow]="true"
    [data]="[currentText]"
  >
    {{ currentText }}
  </p>
</div>
